import React from "react";
import "./index.css";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

const StudyCard = ({
  image,
  altText,
  price,
  cardTitle,
  item,
  cardDescription,
  classNum,
}) => {
  const history = useHistory();

  const handleSelect = (item) => {
    history.push({
      pathname: `/study-module/${item.slug}`,
      state: { item },
    });
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={`View study module: ${cardTitle}`}
      className="bg-white study-card-container cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-500"
      onClick={() => handleSelect(item.study_module)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handleSelect(item.study_module);
        }
      }}
    >
      <div className="w-full md:h-44 xl:h-48">
        <img src={image} alt={altText || cardTitle} className="w-full h-full" />
      </div>

      <p className="p-2 text-h4 font-bold text-darkest title">{cardTitle}</p>

      <div className="card-description-number p-2">
        <p className="text-primary">{price}</p>
        <p className="text-body-large text-greenGradient font-bold mb-1 class">
          {classNum}
        </p>
      </div>
    </div>
  );
};

StudyCard.propTypes = {
  altText: PropTypes.string,
  cardTitle: PropTypes.string,
  cardDescription: PropTypes.string,
  classNum: PropTypes.string,
};

export default StudyCard;
